import * as actionTypes from './actionTypes';
import axios from 'axios';

export const addChatMsg = (payload) => {
    return({
        type: actionTypes.ADD_Chat_MSG,
        username: payload.username,
        content: payload.content,
        timestamp: payload.timestamp,
    });
}

export const errorAddChatMsg = () => {
    return({
        type: actionTypes.Error_ADD_Chat_MSG,
        addChatError: true,
    });
}

export const errorGetAllMsg = () => {
    return({
        type: actionTypes.ERROR_GET_ALL_CHAT_MSG,
        getChatError: true,
    });
}

export const getAllChatMsgs = (payload) => {
    return({
        type: actionTypes.GET_ALL_CHAT_MSGS,
        payload: payload,
    });
}

export const saveChatMsg = (payload) => {
    console.log('saveChatMsg: '+JSON.stringify(payload));
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/SaveChatMsg`;

    return (dispatch) => {
        axios.post(url, payload)
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            dispatch(addChatMsg(response.data));
            dispatch(getAllChatMsg(payload.caseId))
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsg(error));
        });
    }
}

export const getAllChatMsg = (caseId) => {
    
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/GetAllChatMsg`;

    return (dispatch) => {
        axios.post(url, {caseId:caseId})
        .then((response) => {
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            dispatch(getAllChatMsgs(response.data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(errorAddChatMsg(error));
        });
    }
}